import { marketplace, money } from '@sellpy/commons'
import { useSelector } from 'react-redux'
import { getRegion } from '../../../../common/region/region'

export const useMaxCreditAmount = (totalAmount) => {
  const availableCredits = useSelector((state) => state.cart.credit)
  const creditsInSubUnits = money.toSubUnit({
    amount: availableCredits,
    currency: marketplace.CURRENCY[getRegion()]
  })
  const maxCreditAmount = money.gte(creditsInSubUnits, totalAmount)
    ? totalAmount
    : creditsInSubUnits

  return maxCreditAmount
}
